module.exports = "precision mediump float;\n\nvoid main() {\n    gl_FragColor = vec4(0.0, 0.0, 0.4, 0.2);\n}\n\n";